import { Popover as AntPopover } from 'antd';
import type { PopoverProps } from 'antd';

/** Bong bóng nội dung nổi (§9.3.15). Chuyển tiếp thuần. */
export function Popover(props: PopoverProps) {
  return <AntPopover {...props} />;
}
